// extracted by mini-css-extract-plugin
export default {"title":"section_title__BY8BY"};